<template>
  <div>
    <template v-if="!loading && !error">
      <v-container>
        <v-form v-model="formValid" :ref="form"
          :submit="`https://api.service-erp.de/service/kunde/api/v1/Kunde/${parseInt($route.params.id as string)}/action/datei/hochladen`">
          <v-text-field v-model="Bezeichnung" label="Bezeichnung" name="Bezeichnung" :rules="[ruleRequired]" />
          <v-file-input v-model="uploadFile" label="File" name="File"  :rules="[ruleRequired]" :multiple="false" />
          <date-picker class="mt-5" v-model="gueltigVon" label="Gültig Von" name="GueltigVon" />
          <date-picker class="mt-5" v-model="gueltigBis" label="Gültig Bis" name="GueltigBis" />
          <v-btn color="primary" @click="save" :disabled="!formValid" :loading="loadingSave">Speichern</v-btn>
        </v-form>
      </v-container>
    </template>
    <template v-else-if="error">
      <Error :module="dataStorageModule" />
    </template>
    <v-overlay :model-value="loadingSave || loading" class="align-center justify-center" persistent>
      <v-card>
        <v-card-text class="text-center">
          <div class="mb-4">
            <v-progress-circular indeterminate />
          </div>
          <div v-if="loading" class="mt-4">Dokument&shy;anlegung wird geladen</div>
          <div v-if="loadingSave" class="mt-4">Dokument wird gespeichert</div>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>

<script lang="ts" setup>
import router from '@/router';
import {doAlert} from '@/util';
import DatePicker from '@/components/DatePicker.vue';
import {postContactHistoryDocuments} from '@/api/module/contactHistory';
import useDetailContactHistoryStore from '@/store/detailContactHistory';
import {useStorage} from '@/composables/storage';
import {ref, watch, computed} from 'vue';
import {useRoute} from 'vue-router';
import {VNodeRef} from 'vue';

const detailContactHistoryStore = useDetailContactHistoryStore();
useStorage(
    detailContactHistoryStore,
    () => {
      return 'Datei hinzufügen';
    },
    (route) => {
      return {
        KundenNr: parseInt(route.params.id as string),
        Nr: parseInt(route.params.contact_history_id as string),
      };
    },
);
const {loading, error, dataStorageModule} = detailContactHistoryStore;

const route = useRoute();
const loadingSave = ref(false);
const Bezeichnung = ref('');
const GueltigVon = ref('');
const GueltigBis = ref('');
const file = ref(null as File | null);
const formValid = ref(false);
const form = ref(null as (Element & VNodeRef & { validate(): boolean }) | null);

watch(form, (form) => form?.validate());


const uploadFile = computed({
  get(): File[] {
    return file.value ? [file.value] : [];
  },
  set(val: File[]) {
    if (!val) {
      file.value = null;
      return;
    }

    file.value = val[0] ?? null;

    if (Bezeichnung.value == '') {
      if (file.value.name.includes('.')) {
        Bezeichnung.value = file.value.name.split('.').slice(0, -1).join('');
      } else {
        Bezeichnung.value = file.value.name;
      }
    }
  },
});
const gueltigVon = computed({
  get(): string {
    return GueltigVon.value ?? '';
  },
  set(newDate: string | undefined) {
    if (!newDate) {
      GueltigVon.value = '';
      return;
    }
    GueltigVon.value = newDate;
  },
});
const gueltigBis = computed({
  get(): string {
    return GueltigBis.value ?? '';
  },
  set(newDate: string | undefined) {
    if (!newDate) {
      GueltigBis.value = '';
      return;
    }
    GueltigBis.value = newDate;
  },
});

async function save() {
  try {
    loadingSave.value = true;
    form.value?.validate();
    if (!formValid.value) {
      throw new Error('Bitte alle Felder korrekt ausfüllen');
    }
    const formData = new FormData();
    formData.append('GueltigBis', GueltigBis.value!);
    formData.append('GueltigVon', GueltigVon.value!);
    formData.append('Bezeichnung', Bezeichnung.value!);
    formData.append('Datei', file.value! as File);
    await postContactHistoryDocuments(parseInt(route.params.id as string),
        parseInt(route.params.contact_history_id as string), formData);
    router.back();
  } catch (err: any) {
    await doAlert(err.message, 'Fehler');
  } finally {
    loadingSave.value = false;
  }
}
function ruleRequired(val: string | null | undefined): string | true {
  if (!val) return 'erforderlich';

  return true;
}
</script>

